import React, { useEffect, useState } from 'react';
import { dariAlphabet } from './dariAlphabet';
import { dariWords } from './dariWords';
import { listRecordedWords, audioUrlFor, playLoud } from './audioStorage';

function WordDisplay({ currentWord, currentLetterIndex }) {
  const letters = Array.from(currentWord);
  const [recordedSet, setRecordedSet] = useState(new Set());

  useEffect(() => {
    listRecordedWords(dariWords.map((w) => w.dari))
      .then(setRecordedSet)
      .catch(() => {});
  }, []);

  const englishNames = letters.slice(0, currentLetterIndex).reverse().map(dariLetter => {
    const info = dariAlphabet.find(item => item.dari === dariLetter);
    return info ? info.english : '';
  }).join(' ← ');

  const allRevealed = currentLetterIndex === letters.length;
  const showListen = allRevealed && recordedSet.has(currentWord);

  const playSound = () => {
    if (!showListen) return;
    playLoud(audioUrlFor(currentWord));
  };

  return (
    <div className='word-display'>
      <div className='dariWordDisplay'>
        <span className='dariWordText' lang='fa' dir='rtl'>{letters.join('')}</span>
        <button
          type='button'
          className={`listen-icon-btn ${showListen ? '' : 'hidden'}`}
          onClick={playSound}
          aria-label='Listen'
          title='Listen'
          tabIndex={showListen ? 0 : -1}
          aria-hidden={!showListen}
        >
          🔊
        </button>
      </div>
      <div className='englishWordDisplay'>
        {'' + englishNames}
      </div>
    </div>
  );
}

export default WordDisplay;
